import { push } from 'connected-react-router';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { home } from 'src/app/router/paths';
import { getIsAccountFetched, getIsUserPartOfCapsuleAtWork } from 'src/app/state/selectors';
import type { Dispatch } from 'src/app/state/store';

import Renderer from '.';

const mapStateToProps = createStructuredSelector({
  isAccountDataFetched: getIsAccountFetched,
  isUserPartOfCapsuleAtWork: getIsUserPartOfCapsuleAtWork,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  redirectHome: () => dispatch(push(home.toPath())),
});

export default connect(mapStateToProps, mapDispatchToProps)(Renderer);
